<template>
  <div class="big_box">
    <div class="area_header">
      <div class="selcountry_title">{{$t('m.sel_country_area')}}</div>
      <van-search
        class="vant_search"
        v-model="value"
        :placeholder="$t('m.search_for')"
        @input="inputFouce"
      />
    </div>
    <div class="countryList">
      <van-cell-group>
        <van-cell
          :title="item.content"
          :value="'+' + item.countryNum"
          v-for="item in countryArrSel"
          :key="item.id"
          :icon="item.logo"
          @click="selCountryInfo(item)"
        />
      </van-cell-group>
    </div>
  </div>
</template>
<script>
var _self;
import Vue from "vue";
import { Toast, Search } from "vant";

Vue.use(Search);
Vue.use(Toast);

import { myMixin } from "@/tools/mixins.js";
import { getCountryCodeListAjax } from '../api/index';
export default {
  name: "selArea",
  mixins: [myMixin],
  components: {},
  data() {
    return {
      value: "",
      countryArr: [],
      countryArrSel: [],
      countryList: [],
    };
  },
  filters: {},
  watch: {},
  mounted() {
    _self = this;
    _self.getCountryListCode();
  },
  methods: {
    inputFouce() {
      //监听键入值变化
      console.log(_self.value);
      if (_self.value) {
        let searchTxt = _self.value.toLowerCase();//转为小写
        _self.countryArrSel = [];
        _self.countryArr.forEach((item) => {
          let a = item.countryNum + '';
          let b = item.content.toLowerCase();
          if (b.indexOf(searchTxt) > -1) {
            _self.countryArrSel.push(item);
          }else if(a.indexOf(searchTxt) > -1){
            _self.countryArrSel.push(item);
          }
        });
      } else {
        _self.countryArrSel = _self.countryArr;
      }
    },
    selCountryInfo(e) {
      localStorage.setItem('selcountry', JSON.stringify(e))
      this.$router.go(-1);
    },
    getCountryListCode() {
      getCountryCodeListAjax(_self.currentCountry).then(({ data }) => {
        console.log(data)
        Toast.clear();
        if (data.code == 1) {
          _self.countryArr = _self.countryArrSel = data.data.list;
        }
      })
      .catch((error) => {
        console.log(error);
        Toast.clear();
      });
    },
  },
};
</script>

<style scoped>
.big_box {
  height: 100vh;
}
.van-icon__image {
  float: left;
  margin-top: 0.3em;
  background-color: #eee;
  border-radius: 50%;
}
.area_header {
  position: absolute;
  width: 100%;
  top: 0;
  z-index: 99;
}
.vant_search {
  border-top: 1px solid #f5f5f5;
  border-bottom: 1px solid #f5f5f5;
}
.vant_search .van-search__content {
  border-radius: 0.8rem;
}
.selcountry_title {
  height: 0.88rem;
  line-height: 0.88rem;
  text-align: center;
  background-color: #fff;
  text-align: center;
}
.countryList {
  height: 100%;
  padding-top: 2rem;
  box-sizing: border-box;
  overflow: scroll;
  -webkit-overflow-scrolling:touch;
}
</style>



// WEBPACK FOOTER //
// src/pages/selArea.vue